export default __webpack_public_path__ + "static/building-42330fd2c946628b4fe7085bde916e81.webp";